/**
 * Thai person titles from the client master data (cl_id title list, received 2026-07).
 *
 * Hand-maintained — edit directly when the client delivers a new list, applying
 * the same rules: take the "dropdown display" column, skip rows marked
 * ไม่ต้องมี/ไม่พบ/blank, dedupe identical strings, compose decomposed sara am
 * (U+0E4D + U+0E32 → U+0E33), and keep นาย/นาง/น.ส./ด.ช./ด.ญ. pinned first.
 * Keep in sync with set-api-monorepo libs/new-api-core/src/shared/thai-titles.ts.
 */

/**
 * Canonical Thai person titles (the "dropdown display" column of the client
 * master data), deduplicated, in display order.
 */
export const THAI_TITLES = [
  'นาย',
  'นาง',
  'น.ส.',
  'ด.ช.',
  'ด.ญ.',
  'จอมพล',
  'พล.อ.',
  'พล.ท.',
  'พล.ต.',
  'พล.จ.',
  'พ.อ.',
  'พ.ท.',
  'พ.ต.',
  'ร.อ.',
  'ร.ท.',
  'ร.ต.',
  'ว่าที่ ร.ต.',
  'จ.ส.อ.',
  'จ.ส.ท.',
  'จ.ส.ต.',
  'ส.อ.',
  'ส.ท.',
  'ส.ต.',
  'พล.ร.อ.',
  'พล.ร.ท.',
  'พล.ร.ต.',
  'พล.ร.จ.',
  'น.อ.',
  'น.ท.',
  'น.ต.',
  'พ.จ.อ.',
  'พ.จ.ท.',
  'พ.จ.ต.',
  'จ.อ.',
  'จ.ท.',
  'จ.ต.',
  'พล.อ.อ.',
  'พล.อ.ท.',
  'พล.อ.ต.',
  'พล.อ.จ.',
  'พ.อ.อ.',
  'พ.อ.ท.',
  'พ.อ.ต.',
  'พล.ต.อ.',
  'พล.ต.ท.',
  'พล.ต.ต.',
  'พล.ต.จ.',
  'พ.ต.อ.',
  'พ.ต.ท.',
  'พ.ต.ต.',
  'ร.ต.อ.',
  'ร.ต.ท.',
  'ร.ต.ต.',
  'ด.ต.',
  'ส.ต.อ.',
  'ส.ต.ท.',
  'ส.ต.ต.',
  'ม.ร.ว.',
  'หม่อมหลวง',
  'คุณหญิง',
  'ท่านผู้หญิง',
  'ม.จ.',
  'พระวรวงศ์เธอพระองค์เจ้า',
  'พล.ต. หญิง',
  'ว่าที่ ร.ท.',
  'ร.อ. หญิง',
  'ว่าที่ ร.ต. หญิง',
  'พ.อ. หญิง',
  'นายกองเอก',
  'นายกองโท',
  'ว่าที่ ร.อ.',
  'ว่าที่ พ.ต.',
  'ว่าที่ ร.ต.ต.',
  'หม่อม',
  'พล.ร.ต. หญิง',
  'ส.อ. หญิง',
  'น.ท. หญิง',
  'พระ',
  'นายหมวดเอก',
  'จ.ส.อ. หญิง',
  'พ.ต.อ. หญิง',
  'ม.จ. หญิง',
  'ม.ร.ว. หญิง',
  'หม่อมหลวง หญิง',
  'พระวรวงศ์เธอพระองค์เจ้า หญิง',
  'คุณ',
  'ท่านผู้หญิง ม.ล.',
  'เจ้าชาย',
  'เจ้าหญิง',
  'สมเด็จเจ้า',
  'สมเด็จเจ้า หญิง',
  'เจ้าฟ้า',
  'เจ้าฟ้า หญิง',
  'ทูลกระหม่อมหญิง',
  'สมเด็จพระเรียม',
  'พล.อ. หญิง',
  'พล.ท. หญิง',
  'พ.ท. หญิง',
  'พ.ต. หญิง',
  'ว่าที่ พ.ต. หญิง',
  'ว่าที่ ร.อ. หญิง',
  'ร.ท. หญิง',
  'ว่าที่ ร.ท. หญิง',
  'ร.ต. หญิง',
  'จ.ส.ท. หญิง',
  'จ.ส.ต. หญิง',
  'ส.ท. หญิง',
  'ส.ต. หญิง',
  'ร.อ.ม.จ.',
  'ร.อ.ม.จ. หญิง',
  'พล.ท.ม.จ.',
  'พล.ท.ม.จ. หญิง',
  'ร.ต.ม.จ.',
  'ร.ต.ม.จ. หญิง',
  'ร.ท.ม.จ.',
  'ร.ท.ม.จ. หญิง',
  'พ.ท.ม.จ.',
  'พ.ท.ม.จ. หญิง',
  'พ.อ.ม.จ.',
  'พ.อ.ม.จ. หญิง',
  'พ.ต.ม.ร.ว.',
  'พ.ต.ม.ร.ว. หญิง',
  'พ.ท.ม.ร.ว.',
  'พ.ท.ม.ร.ว. หญิง',
  'ส.ต.ม.ร.ว.',
  'ส.ต.ม.ร.ว. หญิง',
  'พ.อ.ม.ร.ว.',
  'พ.อ.ม.ร.ว. หญิง',
  'จ.ส.อ.ม.ร.ว.',
  'จ.ส.อ.ม.ร.ว. หญิง',
  'ร.อ.ม.ร.ว.',
  'ร.อ.ม.ร.ว. หญิง',
  'ร.ต.ม.ร.ว.',
  'ร.ต.ม.ร.ว. หญิง',
  'ส.อ.ม.ร.ว.',
  'ส.อ.ม.ร.ว. หญิง',
  'ร.ท.ม.ร.ว.',
  'ร.ท.ม.ร.ว. หญิง',
  'ร.อ.ม.ล.',
  'ร.อ.ม.ล. หญิง',
  'ส.ท.ม.ล.',
  'ส.ท.ม.ล. หญิง',
  'พล.ท.ม.ล.',
  'พล.ท.ม.ล. หญิง',
  'ร.ท.ม.ล.',
  'ร.ท.ม.ล. หญิง',
  'ร.ต.ม.ล.',
  'ร.ต.ม.ล. หญิง',
  'ส.อ.ม.ล.',
  'ส.อ.ม.ล. หญิง',
  'พล.ต.ม.ล.',
  'พล.ต.ม.ล. หญิง',
  'พ.ต.ม.ล.',
  'พ.ต.ม.ล. หญิง',
  'พ.อ.ม.ล.',
  'พ.อ.ม.ล. หญิง',
  'พ.ท.ม.ล.',
  'พ.ท.ม.ล. หญิง',
  'จ.ส.ต.ม.ล.',
  'จ.ส.ต.ม.ล. หญิง',
  'ว่าที่ร.ต.ม.ล.',
  'ว่าที่ร.ต.ม.ล. หญิง',
  'จ.ส.อ.ม.ล.',
  'จ.ส.อ.ม.ล. หญิง',
  'พ.ท.หลวง',
  'พ.ต.พระเจ้าวรวงศ์เธอพระองค์เจ้า',
  'จ.ส.ต.ม.ร.ว.',
  'จ.ส.ต.ม.ร.ว. หญิง',
  'พล.ต.ม.ร.ว.',
  'พล.ต.ม.ร.ว. หญิง',
  'พ.ต.พระเจ้าวรวงศ์เธอพระองค์ หญิง',
  'ท่านผู้หญิง ม.ร.ว.',
  'พล.อ.ม.ล.',
  'ว่าที่ ร.ต.ม.ร.ว.',
  'พ.อ.หญิง คุณหญิง',
  'พล.อ.หญิง ท่านผู้หญิง',
  'พล.ท.ม.ร.ว.',
  'พล.ท.ม.ร.ว. หญิง',
  'พ.ต.หญิง คุณหญิง',
  'ร.อ.หญิง คุณหญิง',
  'พล.ร.อ. หญิง',
  'พล.ร.ท. หญิง',
  'น.อ. หญิง',
  'น.ต. หญิง',
  'ว่าที่ น.ต.',
  'ว่าที่ น.ต. หญิง',
  'พ.จ.อ. หญิง',
  'พ.จ.ท. หญิง',
  'พ.จ.ต. หญิง',
  'จ.อ. หญิง',
  'จ.ท. หญิง',
  'จ.ต. หญิง',
  'พล.ร.จ. หญิง',
  'น.ท.ม.จ.',
  'น.ท.ม.จ. หญิง',
  'น.อ.ม.จ.',
  'น.อ.ม.จ. หญิง',
  'น.ต.ม.จ.',
  'น.ต.ม.จ. หญิง',
  'พล.ร.ต.ม.ร.ว.',
  'พล.ร.ต.ม.ร.ว. หญิง',
  'น.อ.ม.ร.ว.',
  'น.อ.ม.ร.ว. หญิง',
  'น.ท.ม.ร.ว.',
  'น.ท.ม.ร.ว. หญิง',
  'น.ต.ม.ร.ว.',
  'น.ต.ม.ร.ว. หญิง',
  'น.ท.ม.ล.',
  'น.ท.ม.ล. หญิง',
  'น.ต.ม.ล.',
  'น.ต.ม.ล. หญิง',
  'พ.จ.อ.ม.ล.',
  'พ.จ.อ.ม.ล. หญิง',
  'พล.ร.ต.ม.จ.',
  'พล.ร.ต.ม.จ. หญิง',
  'น.อ.ม.ล.',
  'น.อ.ม.ล. หญิง',
  'พล.ร.ต.ม.ล.',
  'พล.ร.ต.ม.ล. หญิง',
  'น.อ.หญิง คุณหญิง',
  'น.ท.หญิง คุณหญิง',
  'พล.อ.อ. หญิง',
  'พล.อ.ท. หญิง',
  'พล.อ.ต. หญิง',
  'พ.อ.อ. หญิง',
  'พ.อ.ท. หญิง',
  'พ.อ.ต. หญิง',
  'พล.อ.ต.ม.ร.ว.',
  'พล.อ.ต.ม.ร.ว. หญิง',
  'พล.อ.ท.ม.ล.',
  'พล.อ.ท.ม.ล. หญิง',
  'พ.อ.อ.ม.ล.',
  'พ.อ.อ.ม.ล. หญิง',
  'พล.อ.อ.ม.ร.ว.',
  'พล.อ.อ.ม.ร.ว. หญิง',
  'พล.อ.ต.หญิง ม.ล.',
  'พล.อ.ท.ม.ร.ว.',
  'น.อ.หญิง ม.ล.',
  'พล.อ.อ.ม.ล.',
  'พล.อ.อ.ม.ล. หญิง',
  'พล.อ.ต.ม.ล.',
  'พล.ต.อ. หญิง',
  'ว่าที่ พล.ต.อ.',
  'ว่าที่ พล.ต.อ. หญิง',
  'พล.ต.ท. หญิง',
  'ว่าที่ พล.ต.ท.',
  'ว่าที่ พล.ต.ท. หญิง',
  'พล.ต.ต. หญิง',
  'ว่าที่ พล.ต.ต.',
  'ว่าที่ พล.ต.ต. หญิง',
  'พล.ต.จ. หญิง',
  'ว่าที่พล.ต.จ.',
  'ว่าที่พล.ต.จ. หญิง',
  'ว่าที่ พ.ต.อ.',
  'ว่าที่ พ.ต.อ. หญิง',
  'พ.ต.ท. หญิง',
  'ว่าที่ พ.ต.ท.',
  'ว่าที่ พ.ต.ท. หญิง',
  'พ.ต.ต. หญิง',
  'ว่าที่ พ.ต.ต.',
  'ว่าที่ พ.ต.ต. หญิง',
  'ร.ต.อ. หญิง',
  'ว่าที่ ร.ต.อ.',
  'ว่าที่ ร.ต.อ. หญิง',
  'ร.ต.ท. หญิง',
  'ว่าที่ ร.ต.ท.',
  'ว่าที่ ร.ต.ท. หญิง',
  'ร.ต.ต. หญิง',
  'ว่าที่ ร.ต.ต. หญิง',
  'ด.ต. หญิง',
  'ส.ต.อ. หญิง',
  'ส.ต.ท. หญิง',
  'ส.ต.ต. หญิง',
  'นายกองใหญ่',
  'นายกองใหญ่ หญิง',
  'นายกองเอก หญิง',
  'นายกองโท หญิง',
  'นายกองตรี',
  'นายกองตรี หญิง',
  'นายหมวดเอก หญิง',
  'นายหมวดโท',
  'นายหมวดโท หญิง',
  'นายหมวดตรี',
  'นายหมวดตรี หญิง',
  'นายหมู่ใหญ่',
  'นายหมู่ใหญ่ หญิง',
  'นายหมู่เอก',
  'นายหมู่เอก หญิง',
  'นายหมู่โท',
  'นายหมู่โท หญิง',
  'นายหมู่ตรี',
  'นายหมู่ตรี หญิง',
  'พ.ต.ท.ม.จ.',
  'พ.ต.ท.ม.จ. หญิง',
  'พ.ต.อ.ม.จ.',
  'พ.ต.อ.ม.จ. หญิง',
  'พล.ต.ต.ม.ร.ว.',
  'พล.ต.ต.ม.ร.ว. หญิง',
  'พ.ต.ต.ม.ร.ว.',
  'พ.ต.ต.ม.ร.ว. หญิง',
  'พ.ต.ท.ม.ร.ว.',
  'พ.ต.ท.ม.ร.ว. หญิง',
  'พ.ต.อ.ม.ร.ว.',
  'พ.ต.อ.ม.ร.ว. หญิง',
  'ร.ต.อ.ม.ร.ว.',
  'ร.ต.อ.ม.ร.ว. หญิง',
  'ส.ต.อ.ม.ล.',
  'ส.ต.อ.ม.ล. หญิง',
  'พ.ต.อ.ม.ล.',
  'พ.ต.อ.ม.ล. หญิง',
  'พ.ต.ท.ม.ล.',
  'พ.ต.ท.ม.ล. หญิง',
  'ร.ต.ท.ม.ล.',
  'ร.ต.ท.ม.ล. หญิง',
  'ด.ต.ม.ล.',
  'ด.ต.ม.ล. หญิง',
  'พ.ต.ต.ม.ล.',
  'พ.ต.ต.ม.ล. หญิง',
  'ศจ.น.พ.พ.ต.อ.',
  'ร.ต.อ.ม.ล.',
  'พ.ต.อ.หญิง ท่านผู้หญิง',
  'พล.ต.ต.ม.ล.',
  'พล.ต.ต.ม.ล. หญิง',
  'พล.ต.หญิง คุณหญิง',
  'พล.ต.ท.ม.ล.',
  'พล.ต.ท.ม.ล. หญิง',
  'ร.ต.ต.ม.ล.',
  'ร.ต.ต.ม.ล. หญิง',
  'พล.อ.ต.หญิง คุณหญิง',
  'พระครูปลัด',
  'พระสมุห์',
  'พระครูสมุห์',
  'พระครู',
  'พระครูใบฎีกา',
  'พระครูธรรมธร',
  'พระครูสังฆรักษ์',
  'สามเณร',
  'พระปลัด',
  'พระใบฎีกา',
  'พ.อ.อ.ม.ร.ว.',
  'พ.อ.อ.ม.ร.ว. หญิง',
] as const;
